import { render } from "./PageSelector.vue?vue&type=template&id=0d646614"
import script from "./PageSelector.vue?vue&type=script&lang=js"
export * from "./PageSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__